import { Link } from 'react-router-dom';
import { LibraryBig } from 'lucide-react';
import { useLibrary, isDiscoveryAttribute } from '../../lib/library';

const Item = ({ to, title, testId }) => (
  <li><Link to={to} className="block px-3 py-2 rounded-lg font-celestial text-[13px] normal-case tracking-normal text-slate-300 hover:text-amber-200 hover:bg-amber-400/[0.06] transition-colors" data-testid={testId}>{title}</Link></li>
);

export default function PublicationsMenu() {
  const lib = useLibrary();
  if (!lib) return null;
  const pubs = lib.documents.filter((d) => d.body_format === 'text').sort((a, b) => a.publication_order - b.publication_order);
  const groups = [
    { name: 'Books & novels', items: [...lib.books.map((b) => ({ id: b.id, slug: b.slug, title: b.title, to: `/u99/book/${b.slug}` })), ...lib.documents.filter((d) => d.category === 'novel').map((d) => ({ id: d.id, slug: d.slug, title: d.title, to: `/u99/documents/${d.slug}` }))] },
    { name: 'Theses & manuscripts', items: lib.documents.filter((d) => ['thesis', 'manuscript'].includes(d.category) && d.body_format !== 'text').map((d) => ({ id: d.id, slug: d.slug, title: d.title, to: `/u99/documents/${d.slug}` })) },
    { name: 'Discovery Attributes', items: pubs.filter(isDiscoveryAttribute).map((d) => ({ id: d.id, slug: d.slug, title: d.title, to: `/u99/documents/${d.slug}` })) },
    { name: 'Briefs, doctrines & releases', items: pubs.filter((d) => !isDiscoveryAttribute(d)).map((d) => ({ id: d.id, slug: d.slug, title: d.title, to: `/u99/documents/${d.slug}` })) },
  ].filter((g) => g.items.length);
  return (
    <div className="absolute right-0 top-full pt-2 hidden group-hover:block group-focus-within:block" data-testid="u99-publications-menu">
      <div className="w-[30rem] rounded-2xl border border-white/[0.08] bg-[#04070f]/95 backdrop-blur-xl p-3 shadow-2xl max-h-[78vh] overflow-y-auto">
        <Link to="/u99/library" className="flex items-center gap-2 px-3 py-2.5 rounded-xl border border-amber-400/30 font-mono-precision text-[10px] uppercase tracking-[0.25em] text-amber-300 hover:bg-amber-400/[0.08] transition-colors" data-testid="u99-menu-library-link"><LibraryBig size={13} /> Library · every work, open access</Link>
        {groups.map((g) => (
          <div key={g.name} className="mt-3">
            <p className="px-3 py-1 font-mono-precision text-[9px] uppercase tracking-[0.25em] text-amber-300/70">{g.name}</p>
            <ul>{g.items.map((it) => <Item key={it.id} to={it.to} title={it.title} testId={`u99-pub-link-${it.slug}`} />)}</ul>
          </div>
        ))}
      </div>
    </div>
  );
}
